import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { getMatchedComponents, setScrollRestoration } from './utils';

if (process.client) {
  if ('scrollRestoration' in window.history) {
    setScrollRestoration('manual'); // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', function () {
      setScrollRestoration('auto');
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', function () {
      setScrollRestoration('manual');
    });
  }
}

function shouldScrollToTop(route) {
  var Pages = getMatchedComponents(route);

  if (Pages.length === 1) {
    var _Pages$0$options = Pages[0].options,
        options = _Pages$0$options === void 0 ? {} : _Pages$0$options;
    return options.scrollToTop !== false;
  }

  return Pages.some(function (_ref) {
    var options = _ref.options;
    return options && options.scrollToTop;
  });
}

export default function (to, from, savedPosition) {
  // If the returned position is falsy or an empty object, will retain current scroll position
  var position = false;
  var isRouteChanged = to !== from; // savedPosition is only available for popstate navigations (back button)

  if (savedPosition) {
    position = savedPosition;
  } else if (isRouteChanged && shouldScrollToTop(to)) {
    position = {
      x: 0,
      y: 0
    };
  }

  var nuxt = window.$nuxt;

  if ( // Initial load (vuejs/vue-router#3199)
  !isRouteChanged || // Route hash changes
  to.path === from.path && to.hash !== from.hash) {
    nuxt.$nextTick(function () {
      return nuxt.$emit('triggerScroll');
    });
  }

  return new Promise(function (resolve) {
    // wait for the out transition to complete (if necessary)
    nuxt.$once('triggerScroll', function () {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        var hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          var el = document.querySelector(hash);

          if (el) {
            var _getComputedStyle$scr;

            // scroll to anchor by returning the selector
            position = {
              selector: hash
            }; // Respect any scroll-margin-top set in CSS when scrolling to anchor

            var y = Number((_getComputedStyle$scr = getComputedStyle(el)['scroll-margin-top']) === null || _getComputedStyle$scr === void 0 ? void 0 : _getComputedStyle$scr.replace('px', ''));

            if (y) {
              position.offset = {
                y: y
              };
            }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
}